import { gql } from "@apollo/client";

export const GET_ARCHIVOS_PROFESIONAL_LITE = gql`
    query GetArchivosProfesional($idProfesional: Int!) {
        profesionalAdjuntos(idProfesional: $idProfesional) {
            tituloHabilitante {
                idTipoArchivoDocumento
                fechaAlta
                titulo
            }
            certificadoVacunacion {
                idTipoArchivoDocumento
                fechaAlta
                titulo
                extension
            }
            seguroMalaPraxis {
                titulo
                extension
                idArchivo
                fechaDesde
                fechaHasta
            }
            curriculum {
                idTipoArchivoDocumento
                fechaAlta
                titulo
                extension
            }
            contrato {
                idTipoArchivoDocumento
                fechaAlta
                titulo
                extension
            }
            firmaDigital {
                idTipoArchivoDocumento
                fechaAlta
                titulo
                extension
            }
        }
    }
`;


export const GET_ARCHIVOS_PROFESIONAL = gql`
    query GetArchivosProfesional($idProfesional: Int!) {
        profesionalAdjuntos(idProfesional: $idProfesional) {
            tituloHabilitante {
                idTipoArchivoDocumento
                fechaAlta
                titulo
                extension
                contentType
                archivo
            }
            certificadoVacunacion {
                idTipoArchivoDocumento
                fechaAlta
                titulo
                extension
                contentType
                archivo
            }
            seguroMalaPraxis {
                titulo
                extension
                contentType
                archivo
                idArchivo
                fechaDesde
                fechaHasta
            }
            curriculum {
                idTipoArchivoDocumento
                fechaAlta
                titulo
                extension
                contentType
                archivo
            }
            contrato {
                idTipoArchivoDocumento
                fechaAlta
                titulo
                extension
                contentType
                archivo
            }
            firmaDigital {
                idTipoArchivoDocumento
                fechaAlta
                titulo
                extension
                contentType
                archivo
            }
        }
    }
`;


export const adaptSegurosMalaPraxis = (seguros) => {
  return seguros.map((seguro) => ({
    seguroAdjunto: {
      titulo: seguro?.titulo,
      extension: seguro?.extension,
      contentType: seguro?.contentType,
      archivo: seguro?.archivo
    },
    idArchivo: seguro?.idArchivo,
    fechaHasta: seguro?.fechaHasta,
    fechaDesde: seguro?.fechaDesde
  }));
};